'use client';

import { motion } from 'framer-motion';
import React from 'react';

import { Container } from '../container';
import { PillButton } from '../pill-button';
import { jakarta } from '@/lib/fonts';
import { cn } from '@/lib/utils';

export const CTA = ({
  heading,
  sub_heading,
  CTAs,
  locale = 'en',
}: {
  heading: string;
  sub_heading: string;
  CTAs: any[];
  locale?: string;
}) => {
  return (
    <section className="relative overflow-hidden py-20 md:py-32 bg-[#f4f2fc] dark:bg-neutral-900/90 border-t border-b border-[#e5e2f5] dark:border-neutral-800/80">
      {/* Discreet background ambient lighting */}
      <div className="absolute inset-0 pointer-events-none -z-10 overflow-hidden">
        <div className="absolute top-1/2 -translate-y-1/2 right-0 w-[550px] h-[550px] rounded-full blur-[150px] opacity-[0.04] bg-[#c02029]" />
        <div className="absolute top-1/2 -translate-y-1/2 left-0 w-[450px] h-[450px] rounded-full blur-[150px] opacity-[0.035] bg-[#c02029]" />
      </div>

      <Container className="flex flex-col lg:flex-row justify-between items-center gap-10 w-full px-4 sm:px-8">
        <div className="flex flex-col max-w-2xl text-center lg:text-left">
          <motion.h2
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className={cn(
              jakarta.className,
              'text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-[#2e1452] dark:text-white leading-[1.15]'
            )}
          >
            {heading}
          </motion.h2>

          {sub_heading && (
            <motion.p
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="mt-5 text-base sm:text-lg font-medium text-[#3b2d56] dark:text-neutral-300 leading-relaxed"
            >
              {sub_heading}
            </motion.p>
          )}
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="flex flex-wrap items-center justify-center gap-4 flex-shrink-0"
        >
          {CTAs &&
            CTAs.map((cta, index) => {
              const targetUrl = cta.URL?.startsWith('http') || cta.URL?.startsWith('/')
                ? cta.URL.startsWith('/')
                  ? `/${locale}${cta.URL}`
                  : cta.URL
                : `/${locale}/${cta.URL}`;

              return (
                <PillButton
                  key={index}
                  href={targetUrl}
                  text={cta.text}
                />
              );
            })}
        </motion.div>
      </Container>
    </section>
  );
};

export default CTA;
